import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Stack,
  Link,
} from "@mui/material";
import {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
} from "@mui/icons-material";

const FooterLink = ({ to, children }) => (
  <Link
    component={RouterLink}
    to={to}
    underline="none"
    sx={{
      color: "rgba(255,255,255,0.85)",
      fontSize: "0.875rem",
      display: "block",
      mb: 0.8,
      cursor: "pointer",
      transition: "0.2s",
      "&:hover": {
        color: "#90caf9",
        pl: 0.5,
      },
    }}
  >
    {children}
  </Link>
);

export default function Footer() {
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #0b1220, #0f1a2e)",
        color: "#fff",
        mt: 8,
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* LEFT */}
          <Grid item xs={12} md={3}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
              NerdsHub
            </Typography>

            <Typography variant="body2">Email Us</Typography>

            {/* ✅ CLICKABLE EMAIL */}
            <Link
              href="mailto:info@nerdshub.co.in"
              underline="none"
              sx={{
                color: "rgba(255,255,255,0.85)",
                fontSize: "0.875rem",
                display: "inline-block",
                mb: 2,
                cursor: "pointer",
                "&:hover": {
                  color: "#90caf9",
                },
              }}
            >
              info@nerdshub.co.in
            </Link>

            <Stack direction="row" spacing={1}>
              <IconButton color="inherit"><Facebook /></IconButton>
              <IconButton color="inherit"><Twitter /></IconButton>
              <IconButton color="inherit"><Instagram /></IconButton>
              <IconButton color="inherit"><LinkedIn /></IconButton>
            </Stack>
          </Grid>

          {/* COMPANY */}
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
              Company
            </Typography>
            <FooterLink to="/">Home</FooterLink>
            <FooterLink to="/">Who We Are</FooterLink>
            <FooterLink to="/careers">Careers</FooterLink>
            <FooterLink to="/verify">Contact Us</FooterLink>
          </Grid>

          {/* WHAT WE DO */}
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
              What We Do
            </Typography>
            <FooterLink to="/services/api-microservices">
              APIs and Microservices
            </FooterLink>

            <FooterLink to="/services/rpa">
              Robotic Process Automation
            </FooterLink>

            <FooterLink to="/services/mobile-development">
              Mobile App Development
            </FooterLink>

            <FooterLink to="/services/artificial-intelligence">
              Artificial Intelligence
            </FooterLink>

            <FooterLink to="/services/web-development">
              Web Application Development
            </FooterLink>

          </Grid>

          {/* INDUSTRIES */}
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
              Industries We Serve
            </Typography>
            <FooterLink to="/industries">Banking</FooterLink>
            <FooterLink to="/industries">Consumer Devices</FooterLink>
            <FooterLink to="/industries">Manufacturing</FooterLink>
            <FooterLink to="/industries">Insurance</FooterLink>
            <FooterLink to="/industries">Capital Markets</FooterLink>

          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
